import firebase from './'

const analytics = firebase.analytics()

export function logEvent(page) {
    analytics.logEvent(page)
}